"use strict";
/*
 * Created on 25. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var CannibalizationItem_1 = require("./CannibalizationItem");
/**
 * @author Stepan Mik
 */


var WindowPromoEffectBase =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowPromoEffectBase, _DomainObject_1$Domai);

  function WindowPromoEffectBase(id, windowId, promotionId, products, userTotalAmounts, positiveIncrementAmounts, postPromoAmounts, postPromoDates, baselineProducts, baselineAmounts, cannibalization, dailyTotals, //daily split of total amount for product with increment
  historic) {
    var _this;

    _classCallCheck(this, WindowPromoEffectBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowPromoEffectBase).call(this));
    _this.id = id;
    _this.windowId = windowId;
    _this.promotionId = promotionId;
    _this.products = products;
    _this.userTotalAmounts = userTotalAmounts;
    _this.positiveIncrementAmounts = positiveIncrementAmounts;
    _this.postPromoAmounts = postPromoAmounts;
    _this.postPromoDates = postPromoDates;
    _this.baselineProducts = baselineProducts;
    _this.baselineAmounts = baselineAmounts;
    _this.cannibalization = cannibalization;
    _this.dailyTotals = dailyTotals;
    _this.historic = historic;
    return _this;
  }

  return WindowPromoEffectBase;
}(DomainObject_1.DomainObject);

exports.WindowPromoEffectBase = WindowPromoEffectBase;

WindowPromoEffectBase.schema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(WindowPromoEffectBase.name);
  return {
    id: bld.id('id'),
    windowId: bld.id('windowId'),
    promotionId: bld.id('promotionId'),
    products: bld.arr(bld.id('products')),
    userTotalAmounts: bld.arr(bld.bigNum('userTotalAmounts')),
    positiveIncrementAmounts: bld.arr(bld.bigNum('positiveIncrementAmounts')),
    postPromoAmounts: bld.arr(bld.bigNum('postPromoAmounts')),
    postPromoDates: bld.arr(bld.date('postPromoDates')),
    baselineProducts: bld.arr(bld.id('baselineProducts')),
    baselineAmounts: bld.arr(bld.bigNum('baselineAmounts')),
    cannibalization: bld.arr(bld.obj('cannibalization', CannibalizationItem_1.CannibalizationItem.schema, function (mat) {
      return new CannibalizationItem_1.CannibalizationItem(mat.cannibal, mat.victim, mat.amount);
    })),
    dailyTotals: bld.arr(bld.arr(bld.bigNum('dailyTotals'))),
    historic: bld.bool('historic')
  };
}();